 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCVI from '@/components/OEBPS/cvi'
 import LOVE_1 from '@/components/love_1'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSMINI_TOC from '@/components/OEBPS/mini_toc'
 import OEBPSCPN from '@/components/OEBPS/cpn'
 import OEBPSDED from '@/components/OEBPS/ded'
 import OEBPSILL from '@/components/OEBPS/ill'
 import OEBPSGOLSS from '@/components/OEBPS/golss'
 import OEBPSANOTE from '@/components/OEBPS/anote'
 import OEBPSMAP from '@/components/OEBPS/map'
 import OEBPSPRO from '@/components/OEBPS/pro'
 import OEBPSPART01 from '@/components/OEBPS/part01'
 import OEBPSC01 from '@/components/OEBPS/c01'
 import OEBPSC02 from '@/components/OEBPS/c02'
 import OEBPSC03 from '@/components/OEBPS/c03'
 import OEBPSC04 from '@/components/OEBPS/c04'
 import OEBPSC05 from '@/components/OEBPS/c05'
 import OEBPSC06 from '@/components/OEBPS/c06'
 import OEBPSC07 from '@/components/OEBPS/c07'
 import OEBPSC08 from '@/components/OEBPS/c08'
 import OEBPSC09 from '@/components/OEBPS/c09'
 import OEBPSPART02 from '@/components/OEBPS/part02'
 import OEBPSC10 from '@/components/OEBPS/c10'
 import OEBPSC11 from '@/components/OEBPS/c11'
 import OEBPSC12 from '@/components/OEBPS/c12'
 import OEBPSPART03 from '@/components/OEBPS/part03'
 import OEBPSC13 from '@/components/OEBPS/c13'
 import OEBPSC14 from '@/components/OEBPS/c14'
 import OEBPSC15 from '@/components/OEBPS/c15'
 import LOVE_2 from '@/components/love_2'
 import OEBPSPOST from '@/components/OEBPS/post'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSNOTE from '@/components/OEBPS/note'
 import OEBPSBIB from '@/components/OEBPS/bib'
 import OEBPSINDEX from '@/components/OEBPS/index'
 import OEBPSPHOTOGRAPHS from '@/components/OEBPS/photographs'
 import OEBPSALSO from '@/components/OEBPS/also'
 import OEBPSTEASER_TP from '@/components/OEBPS/teaser_tp'
 import OEBPSTEASER01 from '@/components/OEBPS/teaser01'
 import OEBPSTEASERC01 from '@/components/OEBPS/teaserc01'
 import OEBPSAUTH from '@/components/OEBPS/auth'
 import OEBPSNEWSLETTER from '@/components/OEBPS/newsletter'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSCOP from '@/components/OEBPS/cop'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cvi",
 			"name" : "OEBPS/cvi",
 			"component" : OEBPSCVI
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/tp",
 			"name" : "OEBPS/tp",
 			"component" : OEBPSTP
 		},
 		{
 			"path" : "/OEBPS/mini_toc",
 			"name" : "OEBPS/mini_toc",
 			"component" : OEBPSMINI_TOC
 		},
 		{
 			"path" : "/OEBPS/cpn",
 			"name" : "OEBPS/cpn",
 			"component" : OEBPSCPN
 		},
 		{
 			"path" : "/OEBPS/ded",
 			"name" : "OEBPS/ded",
 			"component" : OEBPSDED
 		},
 		{
 			"path" : "/OEBPS/ill",
 			"name" : "OEBPS/ill",
 			"component" : OEBPSILL
 		},
 		{
 			"path" : "/OEBPS/golss",
 			"name" : "OEBPS/golss",
 			"component" : OEBPSGOLSS
 		},
 		{
 			"path" : "/OEBPS/anote",
 			"name" : "OEBPS/anote",
 			"component" : OEBPSANOTE
 		},
 		{
 			"path" : "/OEBPS/map",
 			"name" : "OEBPS/map",
 			"component" : OEBPSMAP
 		},
 		{
 			"path" : "/OEBPS/pro",
 			"name" : "OEBPS/pro",
 			"component" : OEBPSPRO
 		},
 		{
 			"path" : "/OEBPS/part01",
 			"name" : "OEBPS/part01",
 			"component" : OEBPSPART01
 		},
 		{
 			"path" : "/OEBPS/c01",
 			"name" : "OEBPS/c01",
 			"component" : OEBPSC01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js